module.exports = __webpack_public_path__ + "static/img/抖音@2x.6867429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/抖音@2x.png
// module id = xoa1
// module chunks = 28